import * as React from "react"
import {Grid} from "@mui/material";
import {ButtonIconSeeker, TextFieldSeeker} from "@ui-seeker/core";


export default function CreateLineForm({ lineName, isLoading, onLineNameChange, onSave, onCancel }) {
	return <Grid container spacing={1} alignItems="center">
		<Grid item xs={9}>
			<TextFieldSeeker
				fullWidth
				label="New Line Name"
				placeholder="Enter the line name"
				value={lineName}
				onChange={e => onLineNameChange(e.target.value)}
				disabled={isLoading}
			/>
		</Grid>
		<Grid item xs={1.5}>
			<ButtonIconSeeker
				icon="check"
				color="success"
				disabled={!lineName || isLoading}
				loading={isLoading}
				onClick={onSave}
				tooltip="Save Line"
			/>
		</Grid>
		<Grid item xs={1.5}>
			<ButtonIconSeeker
				icon="xmark"
				color="error"
				disabled={isLoading}
				onClick={onCancel}
				tooltip="Cancel"
			/>
		</Grid>
	</Grid>
}
